import React from 'react';

export default function ProposSkeleton() {
  return (
    <div className="w-full p-6 lg:p-16 animate-pulse flex flex-col items-center bg-white rounded-lg">
      <div className="h-12 bg-gray-200 w-1/2 md:w-1/3 rounded mb-8 mt-4" />
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="w-full aspect-[4/5] md:aspect-square bg-gray-200 rounded" />
          <div className="flex flex-col gap-4 justify-center">
             <div className="h-8 bg-gray-200 w-3/4 rounded" />
             <div className="h-6 bg-gray-200 w-full rounded" />
             <div className="h-6 bg-gray-200 w-5/6 rounded" />
             <div className="h-6 bg-gray-200 w-full rounded" />
             <div className="h-6 bg-gray-200 w-4/6 rounded" />
          </div>
      </div>
    </div>
  );
}
